<template>
  <div id="app">
    <vue-page-transition name="fade-in-right">
      <router-view></router-view>
    </vue-page-transition>
    <toast/>
    <confirm-dialog/>
  </div>
</template>

<script>
// import { crono } from 'vue-crono';
import cron from './mixins/cron'
import HelloWorld from './components/HelloWorld'
import Screen from './components/rotation/RotationScreen.vue'
import './assets/css/primeflex.css'
import html2canvas from 'html2canvas'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import Scheduler from './services/scheduler'
import eventBus from './services/event-bus.js'

export default {
  name: 'App',
  mixins: [cron],
  components: {
    HelloWorld,
    Screen,
    Toast,
    ConfirmDialog
  },
  created () {
    this.$scheduler = new Scheduler(this.$store)
  },
  mounted () {
    if (!this.$store.getters['auth/authenticated']) {
      this.$router.push({name: 'login'})
    }
    eventBus.$on('screenshotRequested', this.onScreenshotRequested)
  },
  methods: {
    async onScreenshotRequested (data) {
      console.log('screenshot requested')
      console.log(data)
      console.log(this.$route)
      const screenshot = await html2canvas(document.body)
      this.$store.dispatch('screenshots/upload', Object.assign({}, {
        imagedata: screenshot.toDataURL(),
        page: this.$route.name
      }, data))
    },
    async takeScreenshot () {
      const data = await html2canvas(document.body)
      console.log(data.toDataURL())
    },
    logout () {
      this.$store.dispatch('auth/logout')
    },
    runScheduler () {
      //  this.$scheduler.run()
    },
    async reloadMotions () {
      console.log('reloading motions on cron')
      await this.$store.dispatch('motions/load')
      console.log('...done')
    },
    async optionallyTakeScreenshot () {
      console.log('screenshot?')
      if (this.$store.getters['sessions/allOver']) {
        console.log('Conference has finished, skipping')
        return
      }
      let current = this.$store.getters['sessions/current']
      console.log(current)
      const screenshot = await html2canvas(document.body)
      console.log(this.$route)
      this.$store.dispatch('screenshots/upload', {
        imagedata: screenshot.toDataURL(),
        page: this.$route.name
      })
    },
    cleanupOldScreenshots () {
      this.$store.dispatch('screenshots/cleanup')
    },
    doHardRefresh () {
      console.log('doing hard refresh')
      window.location.reload()
    }
  },
  cron: [
    {
      time: 300000,
      method: 'runScheduler'
    },
    {
      time: 1800000, // 30 mins (1000 x 60 x 30)
      method: 'reloadMotions'
    },
    {
      time: 1000 * 15 * 60,
      method: 'optionallyTakeScreenshot'
    },
    {
      time: 1000 * 60 * 5,
      method: 'cleanupOldScreenshots'
    },
    {
      time: 1000 * 60 * 40,
      method: 'doHardRefresh'
    }
  ]
}
</script>

<style>
@import "primevue/resources/themes/lara-light-blue/theme.css";
@import "primevue/resources/primevue.min.css";
@import "@braid/vue-formulate/dist/snow.min.css";
@import "primeicons/primeicons.css";
@import "purecss/build/pure.css";
@import "vue-multiselect/dist/vue-multiselect.min.css";
@font-face {
  font-family: 'technologybold';
  src: url('../static/fonts/technology-bold-webfont.woff2') format('woff2'),
  url('../static/fonts/technology-bold-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'rubik';
  src: url('../static/fonts/rubik-variablefont_wght-webfont.woff2') format('woff2'),
  url('../static/fonts/rubik-variablefont_wght-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;

}
@font-face {
  font-family: 'rubik_bold';
  src: url('../static/fonts/rubik-bold-webfont.woff2') format('woff2'),
  url('../static/fonts/rubik-bold-webfont.woff') format('woff');
  font-weight: bold;
  font-style: normal;

}
body {
  margin: 0;
  padding: 0;  
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

}
.screen-rotation {
  max-height: 100vh;
  overflow: hidden;
}
.flex-grow-1 {
  flex: 1;
}
.screen.has-padding, .page-inner {
  padding: 1rem;
}
.loading svg {
  width: 200px;
  height: 200px;
}
.loading circle {
  stroke: #222222;
}
.pure-table td {
  background-color: white;
}
.p-menubar {
  font-size: 0.8rem;
}
.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-link {
  padding: 0.5rem 1rem;
}
.blob {
  display: inline-block;
  background: black;
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  margin: 10px;
  height: 20px;
  width: 20px;
  transform: scale(1);
  animation: pulse-black 2s infinite;
}

@keyframes pulse-black {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

.blob.white {
  background: white;
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 1);
  animation: pulse-white 2s infinite;
}

@keyframes pulse-white {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

.blob.red {
  background: rgba(255, 82, 82, 1);
  box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}

.blob.orange {
  background: rgba(255, 121, 63, 1);
  box-shadow: 0 0 0 0 rgba(255, 121, 63, 1);
  animation: pulse-orange 2s infinite;
}

@keyframes pulse-orange {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 121, 63, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 121, 63, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 121, 63, 0);
  }
}

.blob.yellow {
  background: rgba(255, 177, 66, 1);
  box-shadow: 0 0 0 0 rgba(255, 177, 66, 1);
  animation: pulse-yellow 2s infinite;
}

@keyframes pulse-yellow {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 177, 66, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 177, 66, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 177, 66, 0);
  }
}

.blob.blue {
  background: rgba(52, 172, 224, 1);
  box-shadow: 0 0 0 0 rgba(52, 172, 224, 1);
  animation: pulse-blue 2s infinite;
}

@keyframes pulse-blue {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(52, 172, 224, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(52, 172, 224, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(52, 172, 224, 0);
  }
}

.blob.green {
  background: rgba(51, 217, 178, 1);
  box-shadow: 0 0 0 0 rgba(51, 217, 178, 1);
  animation: pulse-green 2s infinite;
}

@keyframes pulse-green {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(51, 217, 178, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0);
  }
}

.blob.purple {
  background: rgba(142, 68, 173, 1);
  box-shadow: 0 0 0 0 rgba(142, 68, 173, 1);
  animation: pulse-purple 2s infinite;
}

@keyframes pulse-purple {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(142, 68, 173, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(142, 68, 173, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(142, 68, 173, 0);
  }
}
.button-success,
.button-error,
.button-warning,
.button-secondary {
  color: white;
  border-radius: 4px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
}

.button-success {
  background: rgb(28, 184, 65);
  /* this is a green */
}

.button-error {
  background: rgb(202, 60, 60);
  /* this is a maroon */
}

.button-warning {
  background: rgb(223, 117, 20);
  /* this is an orange */
}

.button-secondary {
  background: rgb(66, 184, 221);
  /* this is a light blue */
}

.button-xsmall {
  font-size: 70%;
}

.button-small {
  font-size: 85%;
}

.button-large {
  font-size: 110%;
}

.button-xlarge {
  font-size: 125%;
}
input[type="text"] {
  color: black !important;
}
.pure-table thead {
  background-color: #f9f9f9;
}
.pure-table-striped tr:nth-child(2n-1) td {
  background-color: #f7f7f7;
}
.president-motion-view .timer-display {
  font-size: 2.5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue